import { Page } from "commonAssets/pages/Page";
import {
    loading,
    outputDiv,
    userLanguage,
    i18n,
    siteInfo,
    appDomain,
    siteInfoLang,
} from "commonAssets/js/constants";
import { createElement, loadingGif } from "commonAssets/js/helpers";
import { renderLegalOptionsTable } from "commonAssets/pages/Page/home";
import { createOfficialBanner } from "commonAssets/lib/officialBanner";
import { showContactFAQForm } from "commonAssets/lib/showContactFAQForm.js";
export class CustomPage extends Page {
    banks_broker_institutions() {
        const Pages = this.pages;
        Pages.forEach((page) => {
            if (this.slug !== page.PageName) return;

            const PageTitle = createElement(
                "h2",
                { class: "PageTitle" },
                [],
                `Instructions for Filing an Electronic Claim`
            );
            const Separator = createElement("hr");
            const Instructions = createElement("div", {
                id: "efiling-instructions",
            });

            const pageElement = createElement("div", { class: "page" }, [
                PageTitle,
                Separator,
                Instructions,
            ]);
            outputDiv.appendChild(pageElement);

            // Add banks brokers institutions content from template
            addBanksBrokersInstitutionsContent();
        });
        loadingGif(loading, "hide", 250);
    }
}

/**
 * Adds the banks brokers institutions content from the template to the target div.
 */
function addBanksBrokersInstitutionsContent() {
    const template = document.getElementById(
        "banks-brokers-institutions-content-template"
    );
    if (!template) {
        console.warn("Banks brokers institutions content template not found");
        return;
    }

    const targetDiv = document.getElementById("efiling-instructions");
    if (!targetDiv) {
        console.warn("E-filing instructions div not found");
        return;
    }

    const templateContent = template.content.cloneNode(true);
    targetDiv.appendChild(templateContent);
}

export const contactPage = (params) => {
    console.log("[Contact Page] ...");
    // define the constants
    const slug = params.slug;
    const page = params.pages.find((page) => page.PageName === slug);
    // define the elements
    const pageTitle = createElement(
        "h2",
        { class: "page-title mt-2 mb-4" },
        [],
        page.PageTitle
    );
    const pageContent = createElement("div", { class: "page-content row" });
    const pageDiv = createElement("div", { class: "page-div" }, [
        pageTitle,
        pageContent,
    ]);
    const divImptDates = createElement(
        "div",
        {
            class: "my-5 mx-auto",
            id: "ImportantDates",
            style: "max-width: 512px;",
        },
        [],
        params.dates.card()
    );
    const pageColumns = createElement("div", { class: "col-12 col-md-7" });
    // contact column
    if (page.PageContent.length > 0) {
        // make standard contact page
        makeSunPowerContactPage(params, page, userLanguage, pageColumns);
        pageContent.appendChild(pageColumns);
    } else {
        const contactInfoNa = createElement(
            "p",
            { class: "fst-italic" },
            [],
            `No contact information found.`
        );
        pageColumns.appendChild(contactInfoNa);
        pageContent.appendChild(pageColumns);
    }
    // remove the my-5 and mx-auto classes from the divImptDates element
    if (divImptDates.classList.contains("my-5", "mx-auto")) {
        divImptDates.classList.remove("my-5", "mx-auto");
    }
    // important dates column
    const imptDatesColumn = createElement("div", { class: "col-12 col-md-5" }, [
        divImptDates,
    ]);
    pageContent.appendChild(imptDatesColumn);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 250);
};

export const homePage = (params) => {
    console.log("[Home] ...");
    // Get the page slug from the URL and initialize the page object
    const slug = params.slug;
    const page = params.pages.find((page) => page.PageName === slug);

    // Official Settlement Banner
    const bannerOpts = appDomain?.options?.officialBanner;
    const usePageLead =
        typeof bannerOpts === "object"
            ? bannerOpts.pageLead && bannerOpts.display !== false
            : false;

    const officialBanner = createOfficialBanner({
        i18n,
        siteInfoLang,
        appDomain,
        pageLead: usePageLead ? page.PageLead : null,
    });

    // HTML elements for the page
    const pageTitle = createElement(
        "h2",
        {
            class: "page-title mt-2 mb-4 d-none",
            "aria-label": i18n.getTranslation("home_page_aria_title"),
        },
        [],
        page.PageTitle
    );
    const pageBody = createElement("div", { class: "page-body" });
    const pageAlert = createElement(
        "div",
        {
            class: "alert border-dark bg-light text-dark mb-3 pt-4 text-center",
            id: "pageAlert",
        },
        [],
        page.PageAlert
    );
    const pageHeader = createElement(
        "p",
        { class: "text-center h2 my-5 pageHeader", id: "pageHeader_" + slug },
        [],
        page.PageHeader
    );
    const pageSubHeader1 = createElement(
        "p",
        {
            class: "text-center fw-bold fst-italic pageSubHeader1",
            id: "pageSubHeader1_" + slug,
        },
        [],
        page.PageSubHeader1
    );
    const pageSubHeader2 = createElement(
        "p",
        {
            class: "text-center fst-italic pageSubHeader2",
            id: "pageSubHeader2_" + slug,
        },
        [],
        page.PageSubHeader2
    );
    const pageContent = createElement(
        "div",
        { class: "mb-3 pageContent", id: "pageContent_" + slug },
        [],
        page.PageContent
    );
    const pageFooter = createElement(
        "div",
        { class: "py-3", id: "pageFooter" },
        [],
        page.PageFooter
    );
    // Legal Rights and Options Table
    const optionsDIV = renderLegalOptionsTable(slug, page);
    const pageElement = createElement("div", { class: "page", id: slug }, [
        officialBanner,
        Boolean(page.PageAlert) ? pageAlert : "",
        pageHeader,
        pageSubHeader1,
        pageSubHeader2,
        optionsDIV,
        pageFooter,
        pageContent,
    ]);
    const pageDiv = createElement("div", { class: "home-container" }, [
        pageTitle,
        pageBody,
    ]);
    // Append the page elements to the output div
    outputDiv.appendChild(pageElement);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 100);
};

export const appendFaqHeaders = () => {
    const sectionHeading = document.querySelector(
        'div[aria-label="Excluding Yourself From the Settlement Class"]'
    );
    const sectionHeadingElement = createElement(
        "p",
        { class: "mb-3" },
        [],
        "If you do not want to be part of the Settlement but you want to keep any right you may have to sue or continue to sue the Released Defendants’ Parties on your own about the Releasing Plaintiffs’ Claims, then you must take steps to remove yourself from the Settlement Class.  This is called excluding yourself or “opting out.” <strong>Please note: if you bring your own claims, Defendants will have the right to seek their dismissal, including because the suit is not filed within the applicable time periods required for filing suit.  Also, the Defendants may terminate the Settlement if Settlement Class Members who purchased in excess of a certain amount of Azure equity shares seek exclusion from the Settlement Class.​</strong>"
    );
    if (sectionHeading && sectionHeadingElement) {
        sectionHeading.after(sectionHeadingElement);
    }
};

function makeSunPowerContactPage(
    Page,
    page,
    userLanguage,
    parentElement
) {
    // check if the contact page email admin button is disabled
    let displayEmailAdminButton = true;
    if (
        appDomain.options.contactPageEmailAdminButtonDisabled &&
        appDomain.options.contactPageEmailAdminButtonDisabled === true
    ) {
        displayEmailAdminButton = false;
    }
    // build the contact form
    const showFaqsForm = createElement(
        "button",
        { class: "btn btn-primary mt-3", id: "adminEmail" },
        [],
        i18n.getTranslation("contact_admin")
    );
    // build the admin address
    const adminData = page.PageContent[0];
    const adminEmailElement = createElement(
        "span",
        {
            class: "d-block",
            id: "adminEmail",
        },
        [],
        `<strong>${i18n.getTranslation("admin_email")}</strong> <a href="mailto:${siteInfo.email_info}">${siteInfo.email_info}</a>`
    );
    const Admin = createElement("address", { class: "mb-5" }, [
        createElement(
            "span",
            { class: "fw-bold d-block", id: "adminTitle" },
            [],
            adminData.AdminTitle
        ),
        createElement(
            "span",
            { class: "fw-bold d-block", id: "contactCaseTitle" },
            [],
            'SunPower Securities Settlement'
        ),
        createElement(
            "span",
            { class: "d-block", id: "adminName" },
            [],
            adminData.AdminName
        ),
        createElement(
            "span",
            { class: "d-inline-block", id: "adminAddress1" },
            [],
            adminData.AdminAddress1
        ),
        adminData.AdminAddress2
            ? createElement(
                  "span",
                  { id: "adminAddress2" },
                  [],
                  ", " + adminData.AdminAddress2
              )
            : ``,
        createElement("br"),
        createElement(
            "span",
            { class: "d-inline-block", id: "adminCity" },
            [],
            adminData.AdminCity
        ),
        createElement(
            "span",
            { class: "d-inline-block pe-1", id: "adminState" },
            [],
            ", " + adminData.AdminState
        ),
        createElement(
            "span",
            { id: "adminZipCode" },
            [],
            adminData.AdminZipCode
        ),
        siteInfo.phone
            ? createElement(
                  "span",
                  { class: "mt-3 d-block", id: "adminPhone" },
                  [],
                  `<strong>${i18n.getTranslation("admin_phone")}</strong> <a href="tel:+${siteInfo.phone}">${siteInfo.phone}</a>`
              )
            : createElement("br"),
        displayEmailAdminButton ? showFaqsForm : adminEmailElement,
    ]);
    // show faqs form
    if (displayEmailAdminButton) {
        showFaqsForm.addEventListener("click", () => {
            showContactFAQForm(userLanguage);
        });
    }
    // const address
    const Address = createElement("div", { class: "col-md-8" }, [Admin]);
    parentElement.appendChild(Address);
}
